import type { Location, OpportunityLocationData } from './types';

const ROMANIA_CENTER = { lat: 45.9432, lng: 24.9668 };

export function getRomaniaCenter() {
  return ROMANIA_CENTER;
}

/** Extract top N locations by event count from events list */
export function getTopOpportunityLocations(events: { location?: string }[], limit = 6): OpportunityLocationData[] {
  if (!events?.length) return [];
  const counts: Record<string, number> = {};
  const data: Record<string, OpportunityLocationData> = {};
  events.forEach((event) => {
    if (!event.location) return;
    const name = event.location.split(',')[0].trim();
    counts[name] = (counts[name] || 0) + 1;
    if (!data[name]) {
      data[name] = {
        name,
        region: event.location.split(',').slice(1).join(',').trim() || 'Romania',
        latitude: ROMANIA_CENTER.lat,
        longitude: ROMANIA_CENTER.lng,
        opportunityCount: 0,
        activeOpportunities: 0,
      };
    }
  });
  return Object.keys(counts)
    .map((name) => ({ ...data[name], opportunityCount: counts[name], activeOpportunities: counts[name] }))
    .sort((a, b) => b.opportunityCount - a.opportunityCount)
    .slice(0, limit);
}

/** Get display description from Google Places API suggestion result */
export function getDescriptionFromSuggestion(result: Record<string, unknown>, index: number): string {
  const from = (val: unknown): string =>
    typeof val === 'string' ? val : (val && typeof val === 'object' && 'text' in val && typeof (val as { text?: string }).text === 'string' ? (val as { text: string }).text : '');
  const pred = result.placePrediction as Record<string, unknown> | undefined;
  if (pred?.text) return from(pred.text);
  if (result.text) return from(result.text);
  if (result.description) return typeof result.description === 'string' ? result.description : String(result.description);
  if (result.displayName) return String(result.displayName);
  return `Location ${index + 1}`;
}

/** Add location to list if not already present */
export function addLocationIfNew(locations: Location[], newLoc: Location): Location[] {
  const exists = locations.some((loc) => loc.name === newLoc.name);
  return exists ? locations : [...locations, newLoc];
}

export function isGoogleMapsLoaded(): boolean {
  const g = typeof window !== 'undefined' ? (window as unknown as { google?: unknown }).google : undefined;
  const maps = g && typeof g === 'object' && (g as { maps?: unknown }).maps;
  const importLib = maps && typeof maps === 'object' && (maps as { importLibrary?: unknown }).importLibrary;
  return Boolean(importLib);
}
